module.exports = __webpack_public_path__ + "static/media/30-5.3f5dcbbe.mp3";